import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { keyDown } from '../../../utils/helpers';
import {
  formatAmountWithoutDecimals,
  getDateObject,
  formatDate,
  getFormattedCurrentDate,
} from '../../../utils/helpers';
import { postActions } from '../../../utils/constants';

interface ContainerProps {
  disabled?: boolean;
  page?: string;
}

const StyledOuterContainer = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 4px;
  border: solid 1px ${tokens.ColorWhite200};
`;

const StyledContainer = styled.div<ContainerProps>`
  width: 100%;
  border: none;
  background-color: ${tokens.ColorWhite000};
  display: flex;
  cursor: pointer;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  color: ${tokens.ColorGrey600};
  ${(props: any) =>
    props.disabled &&
    css`
      color: ${tokens.ColorGrey300};
    `}
`;

const StyledHoverableSection = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  padding: 16px 16px 16px 16px;
`;

const InfoText = css`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey600};
`;

const HsaName = styled.div<ContainerProps>`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorBrandInteractiveBlue};
  ${(props: any) =>
    props.disabled &&
    css`
      color: ${tokens.ColorGrey300};
    `}
`;

const StyledBalance = styled.div<ContainerProps>`
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 1.38;
  color: ${tokens.ColorGrey800};
  ${(props: any) =>
    props.disabled &&
    css`
      color: ${tokens.ColorGrey300};
    `}
`;

const StyledAccountInfo = styled.div`
  @media (max-width: 767px) {
    margin-bottom: 8px;
  }
`;

const StyledAccountType = styled.div`
  ${InfoText}
`;

const StyledAge = styled.div`
  ${InfoText}
`;

const StyledNew = styled.span`
  color: ${tokens.ColorFunctionalRed900};
`;

const StyledBalanceContainer = styled.div`
  text-align: right;
  padding-right: 16px;
  @media (max-width: 767px) {
    text-align: left;
  }
`;

class HsaCard extends Component<any> {
  props: any;
  state: any;

  render(): JSX.Element {
    // add handleIncludeExclude to next line if uncommenting <ToggleSection>
    const { onClick } = this.props;
    const {
      name,
      accountHolder,
      balance,
      amount,
      asOfDate,
      includeInScenario,
      action,
      page,
      // id,
    } = this.props.data;

    return (
      <React.Fragment>
        <StyledOuterContainer
          page={page}
          onClick={onClick}
          tabIndex={0}
          onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, onClick)}
        >
          <StyledContainer disabled={!includeInScenario}>
            <StyledHoverableSection tabIndex={0} page={page}>
              <StyledAccountInfo>
                <HsaName disabled={!includeInScenario} page={page}>
                  {name}
                  {action === postActions.ADD ? <StyledNew>&nbsp;new!</StyledNew> : ''}
                </HsaName>
                <StyledAccountType>{accountHolder}</StyledAccountType>
              </StyledAccountInfo>
              <StyledBalanceContainer>
                <StyledBalance disabled={!includeInScenario}>
                  {formatAmountWithoutDecimals(balance)}
                </StyledBalance>
                <StyledAge>
                  As of {asOfDate ? formatDate(getDateObject(asOfDate)) : getFormattedCurrentDate()}
                </StyledAge>
              </StyledBalanceContainer>
            </StyledHoverableSection>
            {/* <ToggleSection isOn = {includeInScenario} id = {id} handleIncludeExclude = {handleIncludeExclude}/> */}
          </StyledContainer>
        </StyledOuterContainer>
      </React.Fragment>
    );
  }
}

export default HsaCard;
